import {useState, useMemo, useEffect, useRef} from 'react';
import api from "../services/axiosInstance";
import { useGlobalOpsi } from "../components/GlobalOpsi";
import { backendPort } from '../components/Fungsiku'; 
import { useNotification } from './NotifPopup';
import { useConfirm } from './ModalConfirm';
import { FormasiBan } from './FormasiBan';
import { PageKonten9_Pict } from './Page9_Pict';
import { PageKonten24_Edit } from './Page24_Edit';

export function PageKonten9_Edit({ //baru atau edit?
    statusAksi = 'baru',
    data = null,
    woContext = null,
    loadData =()=>{}, 
    onUpdated = () => {},
    setShowEdit,
    setShowMaster,
    authIdentity = {},
    loadNomorWO =()=>{},
    reloadToken = 0,
}){
  const { globalOpsi, manualResyncGlobalOpsi } = useGlobalOpsi();
  const opsiCabang = globalOpsi.opsiCabang;
  const opsiKapasitas = globalOpsi.opsiKapasitas;
  const opsiKategori = globalOpsi.opsiKategori;
  const opsiMerkMT = globalOpsi.opsiMerkMT;
  const TRANSPORTIR_ADD_VALUE = '__tambah_transportir__';
  //const opsiMT = globalOpsi.opsiMT;
  const { showNotif } = useNotification();
  const { showConfirm } = useConfirm();
  const tahunSekarang = new Date().getFullYear();
  const opsiTahun = Array.from({ length: 50 }, (_, i) => tahunSekarang - i);
  const dataWO = woContext?.dataWO || null;
  const nomorWO = String(woContext?.nomorWO || '').trim();
  const nomorWOEdit = String(woContext?.nomorWOEdit || '').trim();
  const nomorWoPreviewDisplay = (() => {
    const raw = String(nomorWO || '').trim();
    if (!raw) return '-';
    const parts = raw.split('/');
    if (parts.length < 5) return raw;
    parts[parts.length - 1] = '-';
    return parts.join('/');
  })();
  const actorKodeCabang = String(authIdentity?.kode_cabang || "").trim();
  const actorNama = String(authIdentity?.nama || "").trim();
  const isPusat = actorKodeCabang === 'C-1';
  const isAksiBaru = statusAksi === 'baru';
  const sanitizeNopolInput = (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  const kodeCabangDariWO = String(
    dataWO?.kode_cabang || dataWO?.pengirim || actorKodeCabang || ''
  ).trim();
  const parseLampiran = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };
  const buildLampiranUrl = (lampiranPath) => {
    if (!lampiranPath) return '';
    if (String(lampiranPath).startsWith('http')) return lampiranPath;
    return `${backendPort}${lampiranPath}`;
  };
  const normalisasiLampiranUntukUI = (rawLampiran) => {
    return parseLampiran(rawLampiran).map((item) => {
      const type = String(item?.type || '').toLowerCase();
      const isImage = type.startsWith('image/');
      return {
        ...item,
        db_file: item?.file || '',
        file: null,
        caption: item?.caption || '',
        type: item?.type || 'application/octet-stream',
        preview: isImage ? buildLampiranUrl(item?.path) : null,
      };
    });
  };
  const isFileBaru = (item) => item?.file instanceof File;
  const formatYYYYMMDD = (date) => {
      if (!date) return null;
      const d = new Date(date);

      // cek apakah date valid, jika tidak kembalikan dalam bentuk aslinya tanpa eror
      if (isNaN(d.getTime())) return date;

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
      };
  const dataKosong = {
    id_mt: '', 
    nopol: '', 
    kode_cabang: '', 
    merk: '', 
    transportir: '',
    kapasitas: '',
    kategori: '',
    status: '',  
    roda: 16,
    cadangan: 3,
    tahun_pembuatan:0,
    kir: '',
    catatan: '',
    spakboard: '',
    tanggal : new Date(),
    user: '',
    odo_awal: 0
  }    
  const dataProfil = {
    id_mt: data?.id_mt ?? 'K-', 
    nopol: data?.nopol ?? '', 
    kode_cabang: data?.kode_cabang ?? (isAksiBaru ? kodeCabangDariWO : actorKodeCabang), 
    merk: data?.merk ?? '', 
    transportir: data?.transportir ?? '',
    kapasitas: data?.kapasitas ?? '',
    kategori: data?.kategori ?? '',
    status: data?.status ?? '',  
    roda: data?.roda ?? 18,
    cadangan: data?.cadangan ?? 2,
    tahun_pembuatan:data?.tahun_pembuatan ?? 0,
    kir: data?.kir ?? '',
    catatan:
      data?.catatan
      ?? data?.catatan_mt_event
      ?? data?.catatan_mt
      ?? data?.catatan_ban_initial
      ?? data?.catatan_mt_initial
      ?? '',
    spakboard: data?.spakboard ?? '',
    tanggal : data?.tanggal ?? new Date(),
    user: data?.user ?? '',
    odo_awal: data?.odo_awal ?? 0 //daily_mt
  };    
  
  const [attachments, setAttachments] = useState(
    normalisasiLampiranUntukUI(data?.lampiran)
  );
  const [formasi, setFormasi]=useState(Number(dataProfil.roda));
  const [cadangan, setCadangan]=useState(Number(dataProfil.cadangan));
  const [dataNew, setDataNew] = useState(dataProfil);
  const [pertamaKirim, setPertamaKirim] = useState(true);
  const bisaSubmitProfil = 
        dataNew?.kode_cabang?.trim() !== '' && 
        dataNew?.nopol?.trim() !== '' &&
        dataNew?.odo_awal > 0 &&
        dataNew?.tanggal !== '';
  const [adaPerubahan, setAdaPerubahan] = useState(false);
  const [bisaInputBan, setBisaInputBan] = useState(false);
  const [bisaInputLampiran, setBisaInputLampiran] = useState(false);
  const [uploadingLampiran, setUploadingLampiran] = useState(false);
  const [invalidCaptionIndexes, setInvalidCaptionIndexes] = useState([]);
  const [attemptedLampiranSubmit, setAttemptedLampiranSubmit] = useState(false);
  const [isEditRecordDone, setIsEditRecordDone] = useState(false);
  const [idposisi,setIdPosisi] = useState('');
  const [daftarKodeBan, setDaftarKodeBan] = useState({});  
  const [daftarBan, setDaftarBan] = useState([]);
  const [opsiTransportir, setOpsiTransportir] = useState([]);
  const [loadingTransportir, setLoadingTransportir] = useState(false);
  const [showTransportirModal, setShowTransportirModal] = useState(false);
  const [transportirBaru, setTransportirBaru] = useState('');
  const skipNextDaftarBanReloadRef = useRef(false);

  const transportirOptions = useMemo(() => {
    const unique = new Map();
    (Array.isArray(opsiTransportir) ? opsiTransportir : []).forEach((item) => {
      const value = String(item || '').trim();
      if (value) unique.set(value.toLowerCase(), value);
    });
    const current = String(dataNew?.transportir || '').trim();
    if (current) unique.set(current.toLowerCase(), current);
    return [...unique.values()].sort((a, b) => a.localeCompare(b, 'id', { sensitivity: 'base' }));
  }, [dataNew?.transportir, opsiTransportir]);

  const expectedPosisiBan = useMemo(() => {
    const jumlahRoda = Number(dataNew?.roda || 0);
    const jumlahCadangan = Number(dataNew?.cadangan || 0);
    const posisi = [];

    for (let i = 1; i <= jumlahRoda; i += 1) {
      posisi.push(`P-${String(i).padStart(2, '0')}`);
    }
    for (let i = 1; i <= jumlahCadangan; i += 1) {
      posisi.push(`S-${i}`);
    }
    return posisi;
  }, [dataNew?.roda, dataNew?.cadangan]);

  const jumlahProfilBanTerisi = useMemo(() => (
    expectedPosisiBan.filter((id) => Boolean(daftarKodeBan?.[id])).length
  ), [expectedPosisiBan, daftarKodeBan]);
  const minimumRodaTerpasang = useMemo(() => {
    const keys = Object.keys(daftarKodeBan || {});
    return keys.filter((key) => /^P-\d{2}$/i.test(String(key).trim()) && Boolean(daftarKodeBan?.[key])).length;
  }, [daftarKodeBan]);
  const minimumCadanganTerpasang = useMemo(() => {
    const keys = Object.keys(daftarKodeBan || {});
    return keys.filter((key) => /^S-\d+$/i.test(String(key).trim()) && Boolean(daftarKodeBan?.[key])).length;
  }, [daftarKodeBan]);

  const jenisLampiran = useMemo(() => {
    if (!isAksiBaru) return 'initial_otf';
    const rawJenis = String(dataWO?.jenisWO || '').toLowerCase();
    return rawJenis.includes('migrasi') ? 'migrasi_otf' : 'initial_otf';
  }, [isAksiBaru, dataWO]);

  const collectInvalidCaptionIndexes = () => (
    (Array.isArray(attachments) ? attachments : [])
      .map((item, idx) => (String(item?.caption || '').trim() ? -1 : idx))
      .filter((idx) => idx >= 0)
  );
  const lampiranCount = Array.isArray(attachments) ? attachments.length : 0;
  const invalidCaptionCount = collectInvalidCaptionIndexes().length;
  const isLampiranKosongInvalid = attemptedLampiranSubmit && lampiranCount === 0;
  const isLampiranCaptionInvalid = attemptedLampiranSubmit && lampiranCount > 0 && invalidCaptionCount > 0;
  const isLampiranSectionInvalid = isLampiranKosongInvalid || isLampiranCaptionInvalid;
  useEffect(() => {
    let cancelled = false;
    const loadEditRecordStatus = async () => {
      if (statusAksi !== 'edit') {
        setIsEditRecordDone(false);
        return;
      }
      const idMt = String(data?.id_mt || dataNew?.id_mt || '').trim();
      if (!idMt) {
        setIsEditRecordDone(false);
        return;
      }
      try {
        const { data: resData } = await api.get(`${backendPort}/api/main/load_mt_initial_pending_record/${encodeURIComponent(idMt)}`);
        if (cancelled) return;
        const isPending = Boolean(resData?.is_pending_initial);
        setIsEditRecordDone(!isPending);
      } catch (err) {
        if (cancelled) return;
        console.error('Gagal load status record initial MT:', err);
        setIsEditRecordDone(false);
      }
    };
    loadEditRecordStatus();
    return () => {
      cancelled = true;
    };
  }, [statusAksi, data?.id_mt, dataNew?.id_mt]);

  useEffect(() => {
    let cancelled = false;
    const loadTransportirOptions = async () => {
      try {
        setLoadingTransportir(true);
        const { data: resData } = await api.get(`${backendPort}/api/main/opsi_transportir_mt`);
        if (cancelled) return;
        const rows = Array.isArray(resData?.rows) ? resData.rows : [];
        setOpsiTransportir(
          rows
            .map((row) => String(row?.transportir || '').trim())
            .filter(Boolean)
        );
      } catch (err) {
        if (!cancelled) {
          console.error('Gagal load opsi transportir:', err);
          setOpsiTransportir([]);
        }
      } finally {
        if (!cancelled) setLoadingTransportir(false);
      }
    };
    loadTransportirOptions();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleTransportirChange = (value) => {
    const nextValue = String(value || '').trim();
    if (nextValue === TRANSPORTIR_ADD_VALUE) {
      setTransportirBaru('');
      setShowTransportirModal(true);
      return;
    }
    setDataNew((prev) => ({ ...prev, transportir: nextValue }));
    if (nextValue !== String(dataProfil.transportir || '').trim()) setAdaPerubahan(true);
  };

  const handleSimpanTransportirBaru = () => {
    const cleanValue = String(transportirBaru || '').trim();
    if (!cleanValue) {
      showNotif('error', 'Nama transportir wajib diisi');
      return;
    }
    setOpsiTransportir((prev) => {
      const exists = (Array.isArray(prev) ? prev : [])
        .some((item) => String(item || '').trim().toLowerCase() === cleanValue.toLowerCase());
      return exists ? prev : [...(Array.isArray(prev) ? prev : []), cleanValue];
    });
    setDataNew((prev) => ({ ...prev, transportir: cleanValue }));
    if (cleanValue !== String(dataProfil.transportir || '').trim()) setAdaPerubahan(true);
    setShowTransportirModal(false);
    setTransportirBaru('');
  };

  const uploadLampiranDanClose = async () => {
    const idMT = String(dataNew?.id_mt || '').trim();
    if (!idMT) {
      showNotif('error', 'ID MT belum tersedia. Simpan profil MT terlebih dahulu.');
      return;
    }

    const formData = new FormData();
    formData.append('id_mt', idMT);
    formData.append('jenis', jenisLampiran);
    formData.append('nomorWO', String(nomorWO || '').trim());

    const existingLampiran = attachments
      .filter((item) => !isFileBaru(item))
      .map((item) => ({
        name: item?.name || '',
        file: item?.db_file || '',
        path: item?.path || '',
        type: item?.type || '',
        size: Number(item?.size || 0),
        caption: item?.caption || '',
        uploaded_at: item?.uploaded_at || null,
      }));
    formData.append('existing_lampiran', JSON.stringify(existingLampiran));

    attachments.forEach((item) => {
      if (!isFileBaru(item)) return;
      formData.append('files', item.file);
      formData.append('captions', item?.caption || '');
    });

    try {
      setUploadingLampiran(true);
      const { data } = await api.post(`${backendPort}/api/main/upload_lampiran_mt`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      showNotif('success', data?.message || 'Dokumen berhasil disimpan');
      close();
    } catch (err) {
      const message = err?.response?.data?.message || 'Gagal upload lampiran';
      showNotif('error', message);
      console.error(err);
    } finally {
      setUploadingLampiran(false);
    }
  };

  const handleKonfirmasiLampiran = () => {
    setAttemptedLampiranSubmit(true);
    const belumLengkapBan = expectedPosisiBan.length === 0 || jumlahProfilBanTerisi < expectedPosisiBan.length;
    //const belumLengkapBan = false;
    if (belumLengkapBan) {
      showNotif('error', 'Lengkapi profil ban.');
      return;
    }
    if (lampiranCount === 0) {
      setInvalidCaptionIndexes([]);
      showNotif('error', 'Dokumen wajib diupload minimal 1 file.');
      return;
    }

    const invalidIndexes = collectInvalidCaptionIndexes();
    if (invalidIndexes.length > 0) {
      setInvalidCaptionIndexes(invalidIndexes);
      showNotif('error', 'Caption dokumen wajib diisi untuk semua lampiran.');
      return;
    }
    setInvalidCaptionIndexes([]);

    const jumlahDokumen = attachments.length;
    const message = jumlahDokumen > 0
      ? `Upload ${jumlahDokumen} dokumen. Lanjutkan?`
      : 'Tutup Halaman tanpa Upload dokumen. Lanjutkan?';

    showConfirm({
      title: 'Konfirmasi',
      message,
      onConfirm: uploadLampiranDanClose
    });
  };
  useEffect(() => {
    if (!attemptedLampiranSubmit) return;
    setInvalidCaptionIndexes(collectInvalidCaptionIndexes());
  }, [attachments, attemptedLampiranSubmit]);

  async function getDaftarKodeBan(id_mt){
    try{
      const {data} = await api.get(`${backendPort}/api/main/load_daftarkodeban/${id_mt}`);
        setDaftarKodeBan(data ?? {});
        return data;
    }catch(err){
        console.error(err);
        setDaftarKodeBan({});
    }  
  };

  const onKlikBan = (id) => {
      if(!bisaInputBan) {
        showNotif("error","Lengkapi Profil MT terlebih dahulu"); 
        return;}
      setIdPosisi(id);
    };

  const close = ()=>{
    
    setDataNew(dataKosong);
    
    if(statusAksi === 'baru') {
      loadNomorWO();
    }
    if(statusAksi === 'edit'){
      Promise.resolve(loadData()).catch((err) => {
        console.error(err);
      });
    }
    setShowMaster(true);
    setShowEdit(false);
    //refreshGlobalOpsi();
  };   
  useEffect(()=>{
    if(data?.id_mt){
        getDaftarKodeBan(data.id_mt);
      }
    setAttachments(normalisasiLampiranUntukUI(data?.lampiran));
    setDataNew(dataProfil);
    setFormasi(Number(dataProfil.roda));
    setCadangan(Number(dataProfil.cadangan));
    setAdaPerubahan(false);
  },[data?.id_mt, data?.lampiran, actorKodeCabang])
  /*
  useEffect(()=>{
    if(!opsiMT?.length) return;
    if(statusAksi !== 'baru') return;
    
    const sortedMT = [...opsiMT].sort((a, b) => {
      const numA = Number(a.id_mt.split('-')[1]);
      const numB = Number(b.id_mt.split('-')[1]);
      return numA - numB;
    });

    const lastId = sortedMT.at(-1)?.id_mt;
    const nextNumber = Number(lastId?.split('-')[1] ?? 0) + 1;
    const nextId = `K-${String(nextNumber).padStart(5, '0')}`;
    setDataNew(prev => ({ ...prev, id_mt: nextId }));
    },[opsiMT])
  */
  useEffect(() => {
    const loadBan = async () => {
    if (skipNextDaftarBanReloadRef.current) {
      skipNextDaftarBanReloadRef.current = false;
      return;
    }
    try {
      if (!daftarKodeBan) return;
      const listKodeBan = Object.values(daftarKodeBan)??[];
      if(listKodeBan?.length === 0) return;  
      const res = await api.post(
          `${backendPort}/api/main/load_daftarBanThisMT_initial`, //load databan lengkap dengan kode event: initial_otf/migrasi_otf
          { kodeBan: listKodeBan }
        );
      setDaftarBan(res.data);
      } catch (err) {
        console.error(err);
      }
      }
    loadBan();
  }, [daftarKodeBan]);

  useEffect(() => {
    if (!reloadToken) return;
    const idMt = String(data?.id_mt || dataNew?.id_mt || "").trim();
    if (!idMt) return;
    getDaftarKodeBan(idMt);
  }, [reloadToken]);

  const markSkipNextDaftarBanReload = () => {
    skipNextDaftarBanReloadRef.current = true;
  };

  const handleInputMT = async (e) => {
    e.preventDefault();
    setPertamaKirim(false);
    try{
      console.log("daftarKodeBan kirim ke Page24", daftarKodeBan);
      if(!adaPerubahan && !isAksiBaru) {
        showNotif('success', 'Lanjutkan tanpa perubahan');
        setBisaInputBan(true);
        return;  
      };

      if (isAksiBaru && (!dataWO || !nomorWO)) {
        showNotif('error', 'Data Work Order tidak ditemukan. Mulai ulang dari menu Work Order.');
        return;
      }

      showNotif('success', 'Data dikirim.');
      const kodeCabangSubmit = isAksiBaru && !isPusat
        ? actorKodeCabang
        : String(dataNew.kode_cabang || '').trim();

      const kirimAPIEdit = {
        statusAksi : statusAksi,
        id_mt: dataNew.id_mt,
        event_mt: isAksiBaru
          ? (String(dataWO?.jenisWO || '').toLowerCase().includes('migrasi') ? 'migrasi_otf' : 'initial_otf')
          : (String(data?.lampiran_mt_event || '').toLowerCase().includes('migrasi') ? 'migrasi_otf' : 'initial_otf'),
        ...(isAksiBaru ? {
          nomorWO: nomorWO,
          reffWO: { waktu: `${dataWO.start}-${dataWO.end}` },
          jenisWO: dataWO.jenisWO
        } : {
          nomorWOEdit: String(nomorWOEdit || '').trim(),
        }),

        daftar_ban : daftarKodeBan,
        //id_mt: dataNew.id_mt, 
        nopol: isAksiBaru ? sanitizeNopolInput(dataNew.nopol) : dataNew.nopol,
        kode_cabang : kodeCabangSubmit, 
        merk: dataNew.merk,
        transportir: String(dataNew.transportir || '').trim(),
        kapasitas : dataNew.kapasitas,
        kategori : dataNew.kategori,
        status : "Aktif",
        roda : dataNew.roda,
        cadangan : dataNew.cadangan,  
        tahun_pembuatan: dataNew.tahun_pembuatan,
        kir : dataNew.kir,
        catatan : dataNew.catatan,
        odo_awal : dataNew.odo_awal, 
        user : actorNama,
        tanggal : dataNew.tanggal,  
        lampiran : attachments,
      };

      console.log('kirim ke API=', kirimAPIEdit);  
      const res = await api.post(`${backendPort}/api/main/input_mt`, kirimAPIEdit);
      const idMTFinal = res?.data?.id_mt;
      console.log('[Page9_Edit][handleInputMT] response', {
        at: new Date().toISOString(),
        id_mt_response: idMTFinal,
      });
      if (idMTFinal) {
        setDataNew(prev => ({ ...prev, id_mt: idMTFinal }));
      }
      if (typeof manualResyncGlobalOpsi === 'function') {
        await manualResyncGlobalOpsi({ force: true, requestGroup: 'page9-input-mt-sync' });
      }
      if (statusAksi === 'edit') {
        const updatedProfil = {
          ...(data || {}),
          ...(dataNew || {}),
          id_mt: String(idMTFinal || dataNew?.id_mt || '').trim(),
          user: String(actorNama || '').trim(),
          tanggal: dataNew?.tanggal,
          catatan: dataNew?.catatan ?? '',
          catatan_mt: dataNew?.catatan ?? '',
        };
        onUpdated(updatedProfil);
        Promise.resolve(loadData()).catch((err) => {
          console.error(err);
        });
      }
      showNotif('success', 'Update data berhasil');
      setBisaInputBan(true);
    } catch (err) {
      showNotif('error', 'Gagal update');
      setPertamaKirim(true);
      console.error(err);
    } finally {
      
    }
  };

  const tanggalInputInfo = formatYYYYMMDD(data?.tanggal ?? dataNew?.tanggal ?? '');
  const userInputInfo = statusAksi === 'edit'
    ? (String(data?.user || '-').trim() || '-')
    : (String(actorNama || '-').trim() || '-');
  const tanggalEditInfo = statusAksi === 'edit' ? formatYYYYMMDD(new Date()) : '-';
  const userEditInfo = statusAksi === 'edit'
    ? (String(actorNama || '-').trim() || '-')
    : '-';

  return (
    <div className="col-md-12 page9edit-shell">
      {showTransportirModal && (
        <>
          <div className="modal fade show" style={{ display: 'block', zIndex: 1300 }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Tambah Transportir</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowTransportirModal(false)}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  <label className="form-label">Nama Transportir</label>
                  <input
                    className="form-control"
                    value={transportirBaru}
                    onChange={(e) => setTransportirBaru(e.target.value)}
                    maxLength={50}
                    autoFocus
                  />
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowTransportirModal(false)}>
                    Batal
                  </button>
                  <button type="button" className="btn btn-primary" onClick={handleSimpanTransportirBaru}>
                    Simpan
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" style={{ zIndex: 1290 }} />
        </>
      )}
      {idposisi !== '' && <PageKonten24_Edit
            idposisi={idposisi} 
            setIdPosisi={setIdPosisi} 
            daftarBan = {daftarBan}
            setDaftarBan = {setDaftarBan}
            dataMT = {dataNew} 
            setDataMTState={setDataNew}
            authIdentity={authIdentity}
            setDaftarKodeBan = {setDaftarKodeBan}
            daftarKodeBan = {daftarKodeBan}
            isEditRecordDone={isEditRecordDone}
            markSkipNextDaftarBanReload={markSkipNextDaftarBanReload}
            />}
          <div className="card page9edit-card">
            <div className="card-header d-flex justify-content-between align-items-center page9edit-header text-white">
              <span>{statusAksi === 'baru' ? `Input Profil Kendaraan - WO No. ${nomorWoPreviewDisplay}` : `Koreksi Profil Kendaraan - ${data?.id_mt ?? '-'}`}</span>
              <button type="button" className="btn btn-sm btn-outline-light page9show-close-btn" onClick={close}>
                Tutup
              </button>
            </div>
            <div className="card-body page9edit-body">
              <form className="page9edit-form"> 
                <div className='row'>
                  <div className='col-md-4'>
                      <div className= {`card p-3 mb-3 page9edit-step-card ${bisaSubmitProfil ? 'is-ready' : ''}`}>
                        <div className='d-flex justify-content-between vertical-align-middle'>
                        <h5 className ='mt-2 fw-bold page9edit-step-title' style ={{width: 'auto'}} >1. Input Profil MT</h5>
                        <button
                          onClick={handleInputMT} 
                          type="button"
                          style ={{width: 'auto'}} 
                          className={bisaSubmitProfil ? "btn btn-primary" : "btn btn-secondary"} 
                          disabled = {!bisaSubmitProfil || !pertamaKirim}
                          >
                          {bisaSubmitProfil ? <i className='fa fa-solid fa-play'/> : <i className='fa fa-solid fa-lock'/>}
                        </button>
                        </div>
                      </div>
                     
                     <div className='row'> 
                      <div className="col-md-6 mb-3">
                        <label>Transportir</label>
                        <select
                          className="form-select"
                          value={dataNew?.transportir ?? ''}
                          onChange={(e) => handleTransportirChange(e.target.value)}
                          disabled={bisaInputBan || bisaInputLampiran || loadingTransportir}
                        >
                          <option value="">-Pilih Transportir-</option>
                          {transportirOptions.map((item) => (
                            <option key={item} value={item}>{item}</option>
                          ))}
                          <option value={TRANSPORTIR_ADD_VALUE}>Tambah Transportir</option>
                        </select>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label>Cabang</label>
                        <select
                          className="form-select"
                          value={dataNew?.kode_cabang ?? actorKodeCabang}
                          onChange={e => { 
                                            setDataNew(prev=>({...prev, kode_cabang: e.target.value}));
                                            if(e.target.value !== dataProfil.kode_cabang) setAdaPerubahan(true);
                                         }}
                          disabled = {bisaInputBan || bisaInputLampiran || statusAksi === 'edit' || (isAksiBaru && !isPusat)}
                        >
                          <option value = ''>-Pilih Cabang-</option>
                          { 
                            opsiCabang.map(x => (<option key={x.kode_cabang} value={x.kode_cabang}>{x.nama_cabang}</option>
                          ))
                          }
                        </select>  
                      </div>
                    </div>
                  <div className='row'>
                      <div className="mb-3 col-md-6" >
                        <label>No. Polisi</label>
                        <input
                          className="form-control"
                          value={dataNew?.nopol ?? ''}
                          onChange={(e) => {
                                const nopol = sanitizeNopolInput(e.target.value);
                                setDataNew(prev=>({...prev, nopol}));
                                if(nopol !== dataProfil.nopol) setAdaPerubahan(true);}
                                    }
                          disabled = {bisaInputBan || bisaInputLampiran || statusAksi === 'edit'}
                        />
                      </div>
                      <div className="mb-3 col-md-6">
                        <label>ODO Meter Awal</label>
                        <input
                          className="form-control"
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          value={dataNew?.odo_awal ?? 0}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                              setDataNew(prev => ({ ...prev, odo_awal: value }));
                              };
                            if(e.target.value !== dataProfil.odo_awal) setAdaPerubahan(true);
                          }}
                          disabled = {bisaInputBan || bisaInputLampiran || statusAksi === 'edit'}
                        />
                      </div>
                      </div>
                  <div className='row'>
                    <div className="col-md-6 mb-3">
                        <label>Merk</label>
                        <select
                          className="form-select"
                          value={dataNew?.merk ?? ''}
                          onChange={(e) => {
                                setDataNew(prev=>({...prev, merk: e.target.value}));
                                if(e.target.value !== dataProfil.merk) setAdaPerubahan(true);
                            }}
                          disabled = {bisaInputBan || bisaInputLampiran}
                        >
                          <option value={"-"}>-Pilih Merk-</option>
                          { 
                            opsiMerkMT.map((x,i) => (
                            <option key={i} value={x.nama_merk_mt}>{x.nama_merk_mt}</option>
                          ))
                          }
                        </select>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label>Tahun Pembuatan</label>
                        <select
                          className="form-select"
                          value={dataNew?.tahun_pembuatan ?? 0}
                          onChange={e => {
                                            setDataNew(prev=>({...prev, tahun_pembuatan: Number(e.target.value)}));
                                            if(e.target.value !== dataProfil.tahun_pembuatan) setAdaPerubahan(true);
                                        }}
                          disabled = {bisaInputBan || bisaInputLampiran}
                        >
                          <option key='xy' value={''}>-Pilih Tahun-</option>
                          { 
                            opsiTahun.map((x,i) => (
                            <option key={i} value={x}>{x}</option>
                          ))
                          }
                        </select>
                      </div>
                    </div>        
                      
                  <div className='row'>
                      <div className="mb-3 col-md-6" >
                        <label>Kapasitas</label>
                        <select
                          className="form-select"
                          value={dataNew?.kapasitas ?? ''}
                          onChange={e => {
                            setDataNew(prev=>({...prev, kapasitas: e.target.value}));  
                            if(e.target.value !== dataProfil.kapasitas) setAdaPerubahan(true);
                            }}
                          disabled = {bisaInputBan || bisaInputLampiran}  
                          
                        >
                          <option value={""}>--Pilih Kapasitas--</option>
                          { 
                            opsiKapasitas.map((x,i) => (
                            <option key={i} value={x.kapasitas}>{x.kapasitas}</option>
                          ))
                          }
                        </select>
                      </div>
                      <div className="mb-3 col-md-6">
                        <label>Kategori</label>
                        <select
                          className="form-select"
                          value={dataNew?.kategori ?? ''}
                          onChange={e => {
                            setDataNew(prev=>({...prev, kategori: e.target.value})); 
                            if(e.target.value !== dataProfil.kategori) setAdaPerubahan(true); 
                        }}
                          disabled = {bisaInputBan || bisaInputLampiran}
                        >
                          <option value={""}>--Pilih Kategori--</option>
                          { 
                            opsiKategori.map((x,i) => (
                            <option key={i} value={x.kategori}>{x.kategori}</option>
                          ))
                          }
                        </select>
                      </div>
                    </div>

                  <div className='row'>
                      <div className="mb-3 col-md-6">
                        <label>Formasi Roda</label>
                        <select
                          className="form-select"
                          value={dataNew.roda}
                          onChange={e => {
                                const nextRoda = Number(e.target.value);
                                if (nextRoda < minimumRodaTerpasang) {
                                  showNotif('error', `Formasi roda minimal ${minimumRodaTerpasang} karena posisi P-* sudah terpasang.`);
                                  return;
                                }
                                setDataNew(prev=>({...prev, roda: nextRoda}));
                                setFormasi(nextRoda);
                                if(e.target.value !== dataProfil.roda) setAdaPerubahan(true);
                            }}
                          disabled = {bisaInputBan || bisaInputLampiran || isEditRecordDone}  
                        >
                          <option key={''} value={0}>-Pilih Formasi Roda-</option>
                          { 
                            [6,8,10,14,16,18,22].map(x => (
                            <option key = {x} value={x} disabled={x < minimumRodaTerpasang}>{x}</option>
                          ))
                          }
                        </select>
                      </div>
                      <div className="mb-3 col-md-6">
                        <label>Ban Cadangan</label>
                        <select
                          className="form-select"
                          value={dataNew.cadangan}
                          onChange={e => {
                            const nextCadangan = Number(e.target.value);
                            if (nextCadangan < minimumCadanganTerpasang) {
                              showNotif('error', `Ban cadangan minimal ${minimumCadanganTerpasang} karena posisi S-* sudah terpasang.`);
                              return;
                            }
                            setDataNew(prev=>({...prev, cadangan: nextCadangan}));
                            if(e.target.value !== dataProfil.cadangan) setAdaPerubahan(true);
                            setCadangan(nextCadangan)}}
                          disabled = {bisaInputBan || bisaInputLampiran || isEditRecordDone}
                        >
                          <option key = {'xx'} value={0}>-Cadangan-</option>
                          { 
                            [1, 2, 3].map(x => (
                            <option key={x} value={x} disabled={x < minimumCadanganTerpasang}>{x}</option>
                          ))
                          }
                        </select>
                      </div>
                      </div>

                      <div className='row'>
                        <div className="col-md-6 mb-3">
                        <label>Status</label>
                        <select
                          className="form-select"
                          value={dataNew?.status ?? ''}
                          onChange={(e) => {
                                            setDataNew(prev=>({...prev, status: e.target.value}));
                                            if(e.target.value !== dataProfil.status) setAdaPerubahan(true);
                                            }}
                          disabled = {bisaInputBan || bisaInputLampiran}
                        ><option value={"Aktif"}>Aktif</option>
                        </select>    
                        </div>
                        <div className="col-md-6 mb-3">
                        <label>Tanggal KIR</label>
                        <input
                          type="date"
                          className="form-control"
                          value={formatYYYYMMDD(dataNew?.kir ?? '')}
                          max={formatYYYYMMDD(new Date())}
                          onChange={(e) => {
                            setDataNew(prev => ({ ...prev, kir: e.target.value }));
                            if(e.target.value !== dataProfil.kir) setAdaPerubahan(true);
                          }
                          }
                          disabled = {bisaInputBan || bisaInputLampiran}
                        />
                      </div>
                      </div>
                      
                      <div className="mb-3">
                        <label>Catatan terhadap Kendaraan (jika ada)</label>
                        <textarea
                          className="form-control"
                          rows={3}
                          maxLength={150}
                          placeholder='Kondisi kendaraan saat serah terima.'
                          value={dataNew?.catatan ?? ''}
                          onChange={e => {setDataNew(prev=>({...prev, catatan: e.target.value}));
                                            if(e.target.value !== dataProfil.catatan) setAdaPerubahan(true);  
                                        }}
                          disabled = {bisaInputBan || bisaInputLampiran}
                        >
                            <small className="text-muted">
                              {dataNew.catatan?.length || 0}/150 karakter
                            </small>
                        </textarea>
                      </div>

                      <div className='row'>
                        <div className="col-md-6 mb-3">
                          <label>Tanggal Input</label>
                          <input
                            type="date"
                            className="form-control"
                            value={tanggalInputInfo || ''}
                            disabled
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label>User Input</label>
                          <input
                            className="form-control"
                            value={userInputInfo}
                            disabled
                          />
                        </div>
                        {statusAksi === 'edit' && (
                          <div className="col-md-6 mb-3">
                            <label>Tanggal Edit</label>
                            <input
                              type="date"
                              className="form-control"
                              value={tanggalEditInfo === '-' ? '' : tanggalEditInfo}
                              disabled
                            />
                          </div>
                        )}
                        {statusAksi === 'edit' && (
                          <div className="col-md-6 mb-3">
                            <label>User Edit</label>
                            <input
                              className="form-control"
                              value={userEditInfo}
                              disabled
                            />
                          </div>
                        )}
                      </div>
                      
                    </div>              

                <div className='col-md-4'>

                    <div className={`card p-3 mb-3 page9edit-step-card ${bisaInputBan ? 'is-ready' : 'is-locked'}`}>
                      <div className='d-flex justify-content-between vertical-align-middle'>
                        <h5 className ="mt-2 fw-bold page9edit-step-title" style ={{width: 'auto'}}>2. Input Profil Ban</h5>
                        <button type="button" style ={{width: 'auto'}} id="btn2" 
                          className={bisaInputBan ? "btn btn-primary" : "btn btn-secondary"} 
                          disabled={!bisaInputBan} 
                          onClick={()=>{
                            showNotif("success", "Lanjutkan Input Lampiran");
                            setBisaInputLampiran(true);
                          }}>
                          {bisaInputBan ? <i className='fa fa-solid fa-play'/> : <i className='fa fa-solid fa-lock'/>}
                        </button>
                      </div>  
                    </div>

                    <label>INPUT BAN</label>
                    <FormasiBan formasi = {formasi} cadangan={cadangan} onClick={onKlikBan} daftarKodeBan={daftarKodeBan}/>  
                  </div>

                <div className='col-md-4'>
                    
                    <div className={`card p-3 mb-3 page9edit-step-card ${bisaInputLampiran ? 'is-ready' : 'is-locked'} ${isLampiranSectionInvalid ? 'bg-warning-subtle border-warning' : ''}`}>
                      <div className='d-flex justify-content-between vertical-align-middle'>
                        <h5 className ="mt-2 fw-bold page9edit-step-title" style ={{width: 'auto'}}>3. Input Lampiran Profil MT</h5>
                        <button type="button" style ={{width: 'auto'}} id="btn3" 
                          className={bisaInputLampiran ? "btn btn-primary" : "btn btn-secondary"} 
                          disabled={!bisaInputLampiran || uploadingLampiran} 
                          onClick={handleKonfirmasiLampiran}>
                          {uploadingLampiran
                            ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            : (bisaInputLampiran ? <i className='fa fa-solid fa-play'/> : <i className='fa fa-solid fa-lock'/>)}
                        </button>
                      </div>  
                    </div>
                                                
                    <label>LAMPIRKAN GAMBAR/DOKUMEN</label>
                    <div className={`page9edit-lampiran-wrap ${isLampiranSectionInvalid ? 'bg-warning-subtle border border-warning rounded p-2' : ''}`}>
                        <PageKonten9_Pict
                          attachments={attachments}
                          setAttachments={setAttachments}
                          bisaInput={bisaInputLampiran}
                          invalidCaptionIndexes={invalidCaptionIndexes}
                          uploadInputClassName={isLampiranKosongInvalid ? 'bg-warning-subtle border-warning' : ''}
                          onCaptionChange={() => {
                            if (!invalidCaptionIndexes.length) return;
                            setInvalidCaptionIndexes(collectInvalidCaptionIndexes());
                          }}
                        />
                    </div>

                    <div className='row mt-5'>
                        <div className='text-center'>         
                        </div>
                        </div>        
                    </div>
               
                </div>
              </form>
            </div>
          </div>
        </div>
        )
    
};


function StatRow ({ label, value, terpasang, onClick }) {
  return (
    <div className='border-success col-md-6 mb-2'>
    <div className="flex justify-between items-center px-3 py-2 rounded" style={{background: "#e7f5ff"}}>
      <span className="text-gray-900">{label}</span>

      <span onClick={onClick} style={{ cursor: 'pointer' }}
        className={`px-2 py-0.5 rounded text-xs font-medium
          ${terpasang ? 'bg-green-200 text-green-800' : 'bg-red-300 text-red-800'}
        `}
      >
        {value}
      </span>
    </div>
    </div>
  );
}
